import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

const CustomTooltip = ({ active, payload, label, config }) => {
  const formattedPayload = useMemo(
    () => payload
      ?.filter((item) => item.value !== 0)
      ?.sort((a, b) => {
        if (a.value === null) return 1;
        if (b.value === null) return -1;
        if (a.value === null && b.value === null) return 0;
        return b.value - a.value;
      }),
    [payload],
  );

  if (active && formattedPayload?.length) {
    return (
      <div className="chart__custom-tooltip">
        <div className="chart__custom-tooltip--label">{label}</div>
        <div className="chart__custom-tooltip--info ">
          <table className="tooltip-table">
            <tbody>
              {formattedPayload.map((item) => (
                <tr key={item.name}>
                  <td>
                    <div className="d-flex align-items-center">
                      <span className="chart__custom-tooltip--badge" style={{ backgroundColor: item.color }} />
                      <span className="chart__custom-tooltip--name">{item.name}</span>
                    </div>
                  </td>
                  <td className="text-right">
                    <span className="chart__custom-tooltip--value">{item?.payload?.value_formatted}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  if (active && !formattedPayload?.length) {
    const lastItem = payload?.length ? payload[payload.length - 1] : null;

    return (
      <div className="chart__custom-tooltip">
        <div className="chart__custom-tooltip--label">{label}</div>
        <div className="chart__custom-tooltip--info ">
          <table className="tooltip-table">
            <tbody>
              <tr>
                <td>
                  <div className="d-flex align-items-center">
                    <span className="chart__custom-tooltip--badge" style={{ backgroundColor: lastItem ? lastItem.color : '#4D0AE6' }} />
                    <span className="chart__custom-tooltip--name">Total</span>
                  </div>
                </td>
                <td className="text-right">
                  <span className="chart__custom-tooltip--value">{config?.currency_template?.replace('{{value}}', '0.00')}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  return null;
};

CustomTooltip.propTypes = {
  active: PropTypes.bool,
  payload: PropTypes.array,
  label: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  config: PropTypes.object,
};

export default CustomTooltip;
